import React from 'react'

const RaceEntry: React.FC = () => {
    return (
        <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/2 flex text-black p-8">
                <div className="max-w-xl flex flex-col gap-6">
                    <h2 className="text-4xl md:text-6xl font-bold">10k Run Entry</h2>

                    <p>Advance Online Fee £15</p>

                    <p>On the Day Fee £20</p>
                </div>
            </div>

            <div className="w-full md:w-1/2 flex text-black p-8">
                <div className="max-w-xl flex flex-col gap-6">
                    <h2 className="text-4xl md:text-6xl font-bold">3k Run Entry</h2>

                    <p className="text-sm md:text-base">
                        Registration for the Fun Run will take place on the day. Free entry for under 15 year old, £3 for adults.
                    </p>
                </div>
            </div>

            <div className="w-full md:w-1/2 flex text-black p-8">
                <div className="max-w-xl flex flex-col gap-6">
                    <h2 className="text-4xl md:text-6xl font-bold">Included in the Entry</h2>

                    <ul className="list-disc list-inside space-y-2 text-lg">
                        <li>Unique Medal</li>
                        <li>Chip Timed Results</li>
                        <li>Post Run Goodies</li>
                        <li>Free Photos</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default RaceEntry
